module.exports = __webpack_public_path__ + "img/loading-lg.83d39a15.svg";